import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {moduleConfig} from "../config";

const useTools = () => {
    const {allowedActions} = useVerifiedPermissions();

    const tools = [<FilterRecordsButton key='filter'/>, <ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeleteProviderMapping)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }
    if (allowedActions.includes(rbacActions.CreateProviderMapping)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(moduleConfig.titles.plural)}
            tools={useTools()}
        />
    );
};